import React, { FC, useContext } from 'react';
import { AddEntityWatcherButton } from '../../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import styles from './lawyer_follow.module.scss';
import { useRestrictedModal } from '../../../../components/modal/useRestrictedModal';
import { LawyerContext } from '../../LawyerContext';

export const LawyerFollow: FC = () => {
  const source = 'lawyer_page';
  const { openRestrictedModal } = useRestrictedModal();
  const {
    lawyerName,
    lawyerInfos: { lawyerId },
  } = useContext(LawyerContext);

  return (
    <div className={styles.container} id="add-watcher-lawyer">
      <AddEntityWatcherButton
        queryParams={{ lid: lawyerId, q: lawyerName }}
        uniqueId={lawyerId}
        restrict={() =>
          openRestrictedModal({ source: 'want_to_follow_lawyer' })
        }
        source={source}
      />
    </div>
  );
};
